import { ApiService, ApiError } from "../utils/ApiService.js";
import { AppConfig } from "../utils/AppConfig.js";
import { SesionService } from "./SesionService.js";
import { ErrorNegocio } from "./VacacionesService.js";

// Foto de perfil del empleado: GET/POST api/Empleados/{cod}/foto.
// El front recorta y comprime (JPEG chico) antes de subir; la API solo valida y guarda.
export class PerfilService {
  /** URL de la foto actual (con cache-busting) o null si no hay. */
  static urlFoto() {
    const emp = SesionService.empleado();
    if (!emp?.fotoVersion) return null;
    // En modo mock la foto vive en sessionStorage como data URL
    if (AppConfig.api.useMock) return sessionStorage.getItem("mockFoto");
    return ApiService.baseUrl + "/Empleados/" + emp.codigoLegajo + "/foto?v=" + emp.fotoVersion;
  }

  /** Sube un JPEG (data URL) y actualiza la version en la sesion. */
  static async subirFoto(dataUrl) {
    const emp = SesionService.empleado();
    if (!emp) throw new ErrorNegocio("La sesión expiró. Volvé a ingresar.");
    try {
      const rta = await ApiService.post("Empleados/" + emp.codigoLegajo + "/foto", { imagen: dataUrl }, { dedupe: false });
      SesionService.actualizarFoto(rta?.fotoVersion ?? Date.now());
    } catch (error) {
      if (error instanceof ApiError) {
        if (error.status === 400) throw new ErrorNegocio("La imagen no es válida o es demasiado grande.");
        if (error.status === 500 && error.body?.motivo === "almacenamiento") {
          throw new ErrorNegocio("No se pudo guardar la foto en el servidor. Avisale a Sistemas.");
        }
      }
      throw error;
    }
  }
}
